// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import { css } from 'styled-components';

export const responsive = {
  tablet: (...args: any) => css`
    @media (max-width: 63.9375rem) {
      ${css(...args)};
    }
  `,
  mobile: (...args: any) => css`
    @media (max-width: 36.25rem) {
      ${css(...args)};
    }
  `,
};
